import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { FeaturesDataStore } from '../features-data/features-data.store';
import { DialogService } from '../dialog/dialog.service';
import { SettingsDataStore } from '../settings-data/settings-data.store';
import { GlobalBannerService } from '../shared/components/global-banner/global-banner.service';
import { FeaturesDataDispatcher } from '../features-data/features-data.dispatcher';
import { NavigationService } from '../navigation/navigation.service';
import { CreditMemoDataStore } from './credit-memo-data.store';
import { LocalStorageService } from '../browser-manager-data/local-storage.service';
import { CreditMemo } from './credit-memo.model';
import { DocumentDataEffects } from '../document-data/document-data.effects';
import { CreditMemoDataService } from './credit-memo-data.service';
import { IState } from './credit-memo-data.reducer';
import { CreditMemoDataBuilder } from './credit-memo-data.builder';
import { AppStore } from '../../store';
import { UtilsService } from '../shared/services/utils/utils.service';
import { RendererService } from '../renderer/renderer.service';
import { AccountDataStore } from '../account-data/account-data.store';

@Injectable()
export class CreditMemoDataEffects extends DocumentDataEffects<
  IState,
  CreditMemo
> {
  constructor(
    creditMemoDataService: CreditMemoDataService,
    creditMemoDataStore: CreditMemoDataStore,
    creditMemoDataBuilder: CreditMemoDataBuilder,
    accountDataStore: AccountDataStore,
    utilsService: UtilsService,
    rendererService: RendererService,
    actions: Actions,
    appStore: AppStore,
    settingsDataStore: SettingsDataStore,
    featuresDataStore: FeaturesDataStore,
    translateService: TranslateService,
    globalBannerService: GlobalBannerService,
    dialogService: DialogService,
    navigationService: NavigationService,
    localStorageService: LocalStorageService,
    featuresDataDispatcher: FeaturesDataDispatcher
  ) {
    super(
      creditMemoDataService,
      creditMemoDataStore,
      creditMemoDataBuilder,
      accountDataStore,
      utilsService,
      rendererService,
      actions,
      appStore,
      settingsDataStore,
      featuresDataStore,
      translateService,
      globalBannerService,
      dialogService,
      navigationService,
      localStorageService,
      featuresDataDispatcher
    );
  }

  @Effect() loadSearchParams = this.loadSearchParams;
  @Effect() persistSearchParams = this.persistSearchParams;
  @Effect() fetchList = this.fetchList;
  @Effect() fetchFilters = this.fetchFilters;
  @Effect() triggerRefreshFiltersWithDelay = this
    .triggerRefreshFiltersWithDelay;
  @Effect() searchList = this.searchList;
  @Effect() fetchNextPage = this.fetchNextPage;
  @Effect() deleteSelectedEntities = this.deleteSelectedEntities;
  @Effect() batchDeleteEntityStore = this.batchDeleteEntityStore;
  @Effect() batchDeleteEntityNetwork = this.batchDeleteEntityNetwork;
  @Effect() batchSaveEntityStore = this.batchSaveEntityStore;
  @Effect() clearSelectedEntitiesOnFetchOrSearchList = this
    .clearSelectedEntitiesOnFetchOrSearchList;
  @Effect() addToLimitedSelectedList = this.addToLimitedSelectedList;
  @Effect() hideBulkLimitBanner = this.hideBulkLimitBanner;
  @Effect() printDocument = this.printDocument;
  @Effect() markAsPrinted = this.markAsPrinted;
  @Effect() getEntityById = this.getEntityById;
  @Effect() copyDocument = this.copyDocument;
  @Effect() saveCopiedDocument = this.saveCopiedDocument;
  @Effect() redirectToCopiedDocument = this.redirectToCopiedDocument;
  @Effect() sendDocument = this.sendDocument;
  @Effect() saveNewEntity = this.saveNewEntity;
  @Effect() saveNewEntityError = this.saveNewEntityError;
  @Effect() updateEntity = this.updateEntity;
  @Effect() createNewEditingEntity = this.createNewEditingEntity;
  @Effect() refreshEditingEntity = this.refreshEditingEntity;
  @Effect() setEditingEntityContent = this.setEditingEntityContent;
  @Effect() setEditingEntityProperties = this.setEditingEntityProperties;
  @Effect() setEditingEntityField = this.setEditingEntityField;
  @Effect() saveEditingEntity = this.saveEditingEntity;
  @Effect() saveExistingEntityError = this.saveExistingEntityError;
  @Effect() saveEntityStore = this.saveEntityStore;
  @Effect() deleteEntityStore = this.deleteEntityStore;
  @Effect() saveEntityToNetwork = this.saveEntityToNetwork;
  @Effect() deleteEntityNetwork = this.deleteEntityNetwork;
  @Effect() addDocumentItemToEditing = this.addDocumentItemToEditing;
  @Effect() updateDocumentItemInEditing = this.updateDocumentItemInEditing;
  @Effect() deleteDocumentItemFromEditing = this.deleteDocumentItemFromEditing;
  @Effect() moveDocumentItemInEditing = this.moveDocumentItemInEditing;
  @Effect() batchAddDocumentItemsToEditing = this
    .batchAddDocumentItemsToEditing;
  @Effect() updateTaxInEditing = this.updateTaxInEditing;
  @Effect() refreshListAndFiltersOnTaxYearChange = this
    .refreshListAndFiltersOnTaxYearChange;
  @Effect({ dispatch: false }) goToDocumentAddClientScreen = this
    .goToDocumentAddClientScreen;
}
